import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { XIcon } from '@phosphor-icons/react/X';

import type { JSX } from 'react';

const StyledIconButton = styled(IconButton)`
  padding: ${({ theme }) => theme.spacing()};
`;

export interface CloseNotificationButtonProps {
  action: () => void;
}

export function CloseNotificationButton({ action }: CloseNotificationButtonProps): JSX.Element {
  return (
    <StyledIconButton key="close" aria-label="Close" color="inherit" onClick={action} size="large">
      <XIcon />
    </StyledIconButton>
  );
}
